import DashboardHeading from "components/Dashboard/DashboardHeading";
import React from "react";
import ContractorDashboardAnalytics from "../Contractor/ContractorDashboardAnalytics";
export const ContractorDashboardScreen = () => {
  return (
    <>
     <div > <DashboardHeading /> </div>
     <div> <ContractorDashboardAnalytics /></div>
    </>
  );
};
